export default {
	read_only_badge: 'Lecture seule'
};
